// Centralized realistic demo data
// All issues, dates, and timestamps reflect a live operational state
// Reference "now" = late May 2026, mid-morning WIB

export type DemoIssue = {
  id: string
  title: string
  category: 'EKONOMI' | 'POLITIK' | 'SOSIAL' | 'KEAMANAN' | 'PERTAHANAN'
  severity: 'KRITIS' | 'TINGGI' | 'SEDANG'
  volume: string // e.g. "124K mention"
  sentiment: { pos: number; neu: number; neg: number }
  region: string
  status: 'ORGANIK' | 'TERKOORDINASI'
  updatedAt: string // relative time string
  ministry: string // PIC ministry/agency
  href: string
}

// Current trending issues — order = priority for AI Analyst
export const DEMO_ISSUES: DemoIssue[] = [
  {
    id: 'ISSUE-2026-0524-001',
    title: 'Deepfake audio Presiden RI viral di TikTok',
    category: 'KEAMANAN',
    severity: 'KRITIS',
    volume: '2.4M views',
    sentiment: { pos: 4, neu: 12, neg: 84 },
    region: 'Nasional',
    status: 'TERKOORDINASIR',
    updatedAt: '12 menit lalu',
    ministry: 'Komdigi · BSSN',
    href: '/deepfake',
  },
  {
    id: 'ISSUE-2026-0524-002',
    title: 'Harga beras melonjak 18% di 8 provinsi',
    category: 'EKONOMI',
    severity: 'TINGGI',
    volume: '124K mention',
    sentiment: { pos: 10, neu: 20, neg: 70 },
    region: 'Jawa, Sumatera, Sulawesi',
    status: 'ORGANIK',
    updatedAt: '38 menit lalu',
    ministry: 'Kementan · Bulog',
    href: '/hot-issue',
  },
  {
    id: 'ISSUE-2026-0524-003',
    title: 'Operasi tagar #TolakKebijakanX bot-coordinated',
    category: 'POLITIK',
    severity: 'TINGGI',
    volume: '4.8K cuitan · 1.247 akun',
    sentiment: { pos: 6, neu: 22, neg: 72 },
    region: 'Nasional',
    status: 'TERKOORDINASIR',
    updatedAt: '1 jam lalu',
    ministry: 'Komdigi · Polri Siber',
    href: '/bot-detection',
  },
  {
    id: 'ISSUE-2026-0524-004',
    title: 'Ancaman digital jelang kunjungan Presiden ke Papua',
    category: 'PERTAHANAN',
    severity: 'KRITIS',
    volume: '14 ancaman tervalidasi',
    sentiment: { pos: 2, neu: 8, neg: 90 },
    region: 'Papua, Papua Barat',
    status: 'TERKOORDINASIR',
    updatedAt: '2 jam lalu',
    ministry: 'Paspampres · BIN',
    href: '/visit-intel',
  },
  {
    id: 'ISSUE-2026-0524-005',
    title: 'Hoaks penarikan bansos pangan menyebar di WhatsApp',
    category: 'SOSIAL',
    severity: 'TINGGI',
    volume: '89K mention',
    sentiment: { pos: 5, neu: 15, neg: 80 },
    region: 'Nasional',
    status: 'TERKOORDINASIR',
    updatedAt: '3 jam lalu',
    ministry: 'Kemensos · Komdigi',
    href: '/hot-issue',
  },
  {
    id: 'ISSUE-2026-0524-006',
    title: 'Foreign influence kluster server LN soal IKN tahap 2',
    category: 'POLITIK',
    severity: 'TINGGI',
    volume: '65K mention',
    sentiment: { pos: 18, neu: 30, neg: 52 },
    region: 'Kalimantan, Jakarta',
    status: 'TERKOORDINASIR',
    updatedAt: '4 jam lalu',
    ministry: 'BIN · BSSN',
    href: '/foreign-influence',
  },
  {
    id: 'ISSUE-2026-0524-007',
    title: 'Demo buruh upah minimum di Jabar & Banten',
    category: 'EKONOMI',
    severity: 'SEDANG',
    volume: '52K mention',
    sentiment: { pos: 15, neu: 25, neg: 60 },
    region: 'Jabar, Banten',
    status: 'ORGANIK',
    updatedAt: '5 jam lalu',
    ministry: 'Kemnaker · Polri',
    href: '/hot-issue',
  },
  {
    id: 'ISSUE-2026-0524-008',
    title: 'Banjir Demak — distribusi bantuan terkendala akses',
    category: 'SOSIAL',
    severity: 'SEDANG',
    volume: '38K mention',
    sentiment: { pos: 12, neu: 28, neg: 60 },
    region: 'Jawa Tengah',
    status: 'ORGANIK',
    updatedAt: '6 jam lalu',
    ministry: 'BNPB · Kemensos',
    href: '/public-grievance',
  },
]

// Helper: get realistic "today" formatted in Indonesian
export function getTodayIndo() {
  const d = new Date()
  return d.toLocaleDateString('id-ID', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

// Helper: get WIB time string (HH:MM)
export function getNowWib() {
  return new Date().toLocaleTimeString('id-ID', {
    timeZone: 'Asia/Jakarta',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}
